// 會員路由
const name = '導購'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/guide',
  component: Layout,
  children: [
    {
      path: 'DistributionConfig',
      name: `分潤配置`,
      component: () => import('@/view/base/setting/distribution/index')
    },
    {
      path: 'Marketingsalesmanrole',
      name: `導購權限`,
      component: () => import('@/view/guide/salemanRoleConfig')
    },
    {
      path: 'shoppingGuideTask',
      name: `導購任務`,
      component: () => import('@/view/guide/shoppingGuideTask'),
      children: [
        {
          path: 'editor/:task_id?',
          component: () => import('@/view/guide/shoppingGuideTask_editor')
        },
        {
          path: 'statistics',
          component: () => import('@/view/guide/shoppingGuideTaskStatistics')
        }
      ]
    },
    {
      path: 'shopnoticetempl',
      name: `導購消息模版`,
      component: () => import('@/view/guide/shopnoticetempl')
    },
    {
      path: 'SalemanLoginHistory',
      name: `導購簽到記錄`,
      component: () => import('@/view/guide/SalemanLoginHistory')
    },
    {
      path: 'marketingsalesman',
      name: `店鋪導購員`,
      component: () => import('@/view/guide/salesman')
    },
    {
      path: 'coupongrantset',
      name: `優惠券發放設置`,
      component: () => import('@/view/member/cardticket/couponGrantSet')
    },
    {
      path: 'shopactivities',
      name: `導購知識庫`,
      component: () => import('@/view/guide/shopactivities'),
      children: [
        {
          path: 'editor',
          component: () => import('@/view/guide/shopActivities_editor')
        }
      ]
    },
    {
      path: 'shoppingguidenotification',
      name: `導購員通知`,
      component: () => import('@/view/guide/shoppingguidenotification'),
      children: [
        {
          path: 'editor',
          component: () => import('@/view/guide/shoppingguidenotification_editor')
        }
      ]
    },
    {
      path: 'profitlist',
      name: `業績統計`,
      component: () => import('@/view/mall/profit/list')
    },
    {
      path: 'salemancustomercomplaints',
      name: `導購員投訴`,
      component: () => import('@/view/guide/salemanCustomerComplaints')
    },
    {
      path: 'guide/qywx/addressBook',
      name: `通訊錄`,
      component: () => import('@/view/base/setting/addressBook/index')
    }
  ]
}
